import { createAction, props } from '@ngrx/store';
import { TFAMethod } from '../../interfaces/tfa-method';

export const loadTFAMethods = createAction('[TFAMethods/API] Load TFAMethods');

export const loadTFAMethodsSuccess = createAction(
  '[TFAMethods/API] Load TFAMethods Success',
  props<{ tfaMethods: TFAMethod[] }>()
);

export const loadTFAMethodsFailure = createAction('[TFAMethods/API] Load TFAMethods Failure', props<{ error: unknown }>());

export const clearTFAMethods = createAction('[TFAMethods/API] Clear TFAMethods');
